
export function range(start, end, step) {
  var _end = end || start;
  var _start = end ? start : 0;
  var _step = step || 1;
  return Array((_end - _start) / _step).fill(0).map((v, i) => _start + (i * _step));
}

export const arrayToObject = (array, keyField) =>
 array.reduce((obj, item) => {
   obj[item[keyField]] = item
   return obj
}, {})

export const merge = (arr1, arr2) => {
  if (arr2 == null) return arr1;
  if (arr1 == null) return arr2;

  return arr1.concat(arr2.filter(i => !arr1.includes(i)));
}

export class Collection {
  constructor(items, itemsPerPage) {
    this.items = items;
    this.itemsPerPage = itemsPerPage;

    this.numberOfPages =
        Math.ceil(this.items.length / this.itemsPerPage);
  }

  get(param) {
    const page = param || 0;
    const itemsPerPage = this.itemsPerPage;
    const numberOfItems = this.items.length;

    const fromElem = Math.min(page * itemsPerPage, numberOfItems);
    const toElem = Math.min((page + 1) * itemsPerPage, numberOfItems);

    return this.items.slice(fromElem, toElem);
  }

  size() {
    return this.numberOfPages;
  }
};
